import { render, staticRenderFns } from "./question-row.vue?vue&type=template&id=1a69f478&scoped=true"
import script from "./question-row.vue?vue&type=script&lang=js"
export * from "./question-row.vue?vue&type=script&lang=js"
import style0 from "./question-row.vue?vue&type=style&index=0&id=1a69f478&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a69f478",
  null
  
)

export default component.exports